// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { FaStar, FaShoppingCart } from "react-icons/fa";
// import axios from "axios";
// import { useTranslation } from "react-i18next";

// /* IMAGE IMPORT */
// import bannerImg from "../../images/special_pro_banner_img.jpg";


// const API_BASE = "https://api.mahal.qa/api";

// const SpecialProducts = () => {
//   const [products, setProducts] = useState([]);
// const [ratings, setRatings] = useState({});
// const { t, i18n } = useTranslation();
// const isArabic = i18n.language === "ar";

// const getProductName = (item) => {
//   return isArabic
//     ? item.name_ar || item.product_name_arabic || item.title_ar || item.title || item.name
//     : item.name_en || item.product_name_english || item.title_en || item.title || item.name;
// };

// const localizeNumber = (value) => {
//   return new Intl.NumberFormat(isArabic ? "ar-QA" : "en-US").format(
//     Number(value || 0)
//   );
// };

// const localizeDecimal = (value) => {
//   return new Intl.NumberFormat(isArabic ? "ar-QA" : "en-US", {
//     minimumFractionDigits: 1,
//     maximumFractionDigits: 1,
//   }).format(Number(value || 0));
// };

// const localizeCurrency = (value) => {
//   return isArabic
//     ? `${localizeNumber(value)} ${t("qar")}`
//     : `${t("qar")} ${localizeNumber(value)}`;
// };


//   /* ================= FETCH FROM BACKEND ================= */

//   useEffect(() => {
//     fetch("https://api.mahal.qa/api/special-products")
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.products) {
//           setProducts(data.products);
//           fetchRatings(data.products);
//         }
//       })
//       .catch((err) =>
//         console.error("Error fetching special products:", err)
//       );
//   }, []);

//   const fetchRatings = async (products) => {
//   try {
//     const ratingData = {};

//     await Promise.all(
//       products.map(async (p) => {
//         const productId = p.id || p.product_id;

//         try {
//           const res = await fetch(
//             `https://api.mahal.qa/api/reviews/product/${productId}`
//           );
//           const data = await res.json();

//           if (data.length > 0) {
//             const total = data.reduce((sum, r) => sum + r.rating, 0);
//             ratingData[productId] = total / data.length;
//           } else {
//             ratingData[productId] = 0;
//           }
//         } catch {
//           ratingData[productId] = 0;
//         }
//       })
//     );

//     setRatings(ratingData);
//   } catch (err) {
//     console.error("Rating fetch error:", err);
//   }
// };

//   /* ================= ADD TO CART ================= */

// const addToCart = (product) => {

//   console.log("PRODUCT:", product);

//   const token = localStorage.getItem("token");

//   if (!token) {
//     alert(t("please_login"));
//     return;
//   }

//   const productId = product.id || product.product_id;

//   if (!productId) {

//     alert(t("invalid_product"));

//     console.error(
//       "BAD PRODUCT:",
//       product
//     );

//     return;
//   }

//   axios
//     .post(
//       `${API_BASE}/cart/add`,
//       {
//         product_id: Number(productId),
//         quantity: 1,
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     )

//     .then((res) => {

//       console.log(
//         "SUCCESS:",
//         res.data
//       );

//       // ✅ Product already exists
//       if (res.data.status === "exists") {

// alert(t("product_already_cart"));

//       }

//       // ✅ New product added
//       else {

//         alert(t("added_to_cart"));

//       }

//     })

//     .catch((err) => {

//       console.log(
//         "FULL ERROR:",
//         err.response || err
//       );

// alert(
//   err.response?.data?.error ||
//   err.response?.data?.message ||
//   t("backend_error")
// );

//     });

// };

//   return (
//    <section className="mm-special-section pt-5 pb-5" dir={isArabic ? "rtl" : "ltr"}>
//       <div className="container">

//         {/* HEADING */}
//         <div className="text-center mb-5">
//           <span className="mm-section-badge">{t("special_products")}</span>
//           <h2 className="mm-section-title">{t("exclusive_deals_kitchen")}</h2>
//         </div>

// <div className="row g-4">
//           {/* LEFT PROMO BANNER */}
//           <div className="col-xl-4">
//             <div className="mm-special-banner">
//               <img src={bannerImg} alt="special banner" />
//               <div className="mm-special-overlay"></div>

//               <div className="mm-special-banner-content" dir={isArabic ? "rtl" : "ltr"}>
//                 <h4>{t("weekly_discounts")}</h4>
//                 <h3>{t("fresh_fruits_vegetables")}</h3>
//                 <p>{t("save_more_bulk")}</p>
//                 <Link to="/CategorieList" className="mm-special-btn">
//                   {t("shop_now")} →
//                 </Link>
//               </div>
//             </div>
//           </div>

//           {/* RIGHT PRODUCT GRID */}
//           <div className="col-xl-8">
//             <div className="row g-4">

//                 {products.slice(0, 8).map((item, index) => {
//                   const productId = item.id || item.product_id;   // ✅ ADD
//                   const ratingValue = ratings[productId] || 0;    // ✅ ADD

//                   return (
//                     <div className="col-md-6 col-lg-3" key={productId || index}>
//                       <div className="mm-special-card">

//                         {item.label && (
//                             <span
//                               className="mm-discount-tag"
//                               style={{
//                                 left: isArabic ? "auto" : "10px",
//                                 right: isArabic ? "10px" : "auto",
//                                 top: "10px",
//                                 zIndex: 5,
//                               }}
//                             >
//                               {isArabic ? item.label_ar || t("new") : item.label}
//                             </span>
//                         )}

//                         <div className="mm-special-img">
//                           <img
//                             src={item.img1 || "/placeholder.jpg"}
//                            alt={getProductName(item)}
//                           />

//                           <Link
//                             to={`/shopdetails/${productId}`}
//                             style={{
//                               position: "absolute",
//                               top: "10px",
//                               left: isArabic ? "10px" : "auto",
//                               right: isArabic ? "auto" : "10px",
//                               zIndex: 6,
//                             }}
//                           >
//                             <i className="fa fa-eye"></i>
//                           </Link>
//                         </div>

//                         <div className="mm-special-content" dir={isArabic ? "rtl" : "ltr"}>
//                           <h5>{getProductName(item)}</h5>

//                           {/* ✅ FIXED RATING */}
//                           <div className="mm-rating">
//                             {Array.from({ length: 5 }).map((_, i) => (
//                               <FaStar
//                                 key={i}
//                                 color={
//                                   i < Math.round(ratingValue)
//                                     ? "#f59e0b"
//                                     : "#e5e7eb"
//                                 }
//                               />
//                             ))}

//                             <span className="ms-1 text-muted">
//                               ({localizeDecimal(ratingValue)})
//                             </span>
//                           </div>

//                           <div className="mm-price">
//                           <span className="mm-new">
//                             {localizeCurrency(item.price_numeric || item.price_per_unit)}
//                           </span>
//                               {item.old && (
//                                 <span className="mm-old">
//                                   {localizeCurrency(item.old)}
//                                 </span>
//                               )}
//                           </div>

//                           <button
//                             className="mm-cart-btn"
//                             onClick={() => addToCart(item)}
//                           >
//                             <FaShoppingCart /> {t("add")}
//                           </button>

//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}

//             </div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default SpecialProducts;



import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaStar, FaShoppingCart } from "react-icons/fa";
import axios from "axios";

import bannerImg from "../../images/special_pro_banner_img.jpg";

const API_BASE = "https://api.mahal.qa/api";

const SpecialProducts = () => {
  const [products, setProducts] = useState([]);
  const [ratings, setRatings] = useState({});

  /* ================= FETCH FROM BACKEND ================= */
  useEffect(() => {
    fetch("https://api.mahal.qa/api/special-products")
      .then((res) => res.json())
      .then((data) => {
        if (data.products) {
          setProducts(data.products);
          fetchRatings(data.products);
        }
      })
      .catch((err) =>
        console.error("Error fetching special products:", err)
      );
  }, []);

  const fetchRatings = async (products) => {
    try {
      const ratingData = {};

      await Promise.all(
        products.map(async (p) => {
          const productId = p.id || p.product_id;

          try {
            const res = await fetch(
              `https://api.mahal.qa/api/reviews/product/${productId}`
            );
            const data = await res.json();

            if (data.length > 0) {
              const total = data.reduce((sum, r) => sum + r.rating, 0);
              ratingData[productId] = total / data.length;
            } else {
              ratingData[productId] = 0;
            }
          } catch {
            ratingData[productId] = 0;
          }
        })
      );

      setRatings(ratingData);
    } catch (err) {
      console.error("Rating fetch error:", err);
    }
  };

  /* ================= ADD TO CART ================= */
  const addToCart = (product) => {
    console.log("PRODUCT:", product);

    const token = localStorage.getItem("token");

    if (!token) {
      alert("Please login");
      return;
    }

    const productId = product.id || product.product_id;

    if (!productId) {
      alert("Invalid product ❌");
      console.error("BAD PRODUCT:", product);
      return;
    }

    axios
      .post(
        `${API_BASE}/cart/add`,
        {
          product_id: Number(productId),
          quantity: 1,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        console.log("SUCCESS:", res.data);
        alert("Added to cart ✅");
      })
      .catch((err) => {
        console.log("FULL ERROR:", err.response || err);

        alert(
          err.response?.data?.error ||
          err.response?.data?.message ||
          "Backend error"
        );
      });
  };

  return (
    <section className="mm-special-section pt-5 pb-5">
      <div className="container">

        {/* HEADING */}
        <div className="text-center mb-5">
          <span className="mm-section-badge">Special Products</span>
          <h2 className="mm-section-title">Exclusive Deals for Your Kitchen</h2>
        </div>

        <div className="row g-4">

          {/* LEFT PROMO BANNER */}
          <div className="col-xl-4">
            <div className="mm-special-banner">
              <img src={bannerImg} alt="special banner" />
              <div className="mm-special-overlay"></div>

              <div className="mm-special-banner-content">
                <h4>Weekly Discounts</h4>
                <h3>Fresh Fruits & Vegetables</h3>
                <p>Save more when you buy in bulk.</p>
                {/* <Link to="/CategorieList" className="mm-special-btn"> */}
                <Link to="/offer-products?type=special" className="mm-special-btn">
                  Shop Now →
                </Link>
              </div>
            </div>
          </div>

          {/* RIGHT PRODUCT GRID */}
          <div className="col-xl-8">
            <div className="row g-4">

              {products.slice(0, 8).map((item, index) => {
                const productId = item.id || item.product_id;   // ✅ ADD
                const ratingValue = ratings[productId] || 0;    // ✅ ADD

                return (
                  <div className="col-md-6 col-lg-3" key={productId || index}>
                    <div className="mm-special-card">

                      {item.label && (
                        <span className="mm-discount-tag">
                          {item.label}
                        </span>
                      )}

                      <div className="mm-special-img">
                        <img
                          src={item.img1 || "/placeholder.jpg"}
                          alt={item.title || item.name}
                        />

                        <Link to={`/shopdetails/${productId}`}>
                          <i className="fa fa-eye"></i>
                        </Link>
                      </div>

                      <div className="mm-special-content">
                        <h5>{item.title || item.name}</h5>

                        {/* ✅ FIXED RATING */}
                        <div className="mm-rating">
                          {Array.from({ length: 5 }).map((_, i) => (
                            <FaStar
                              key={i}
                              color={
                                i < Math.round(ratingValue)
                                  ? "#f59e0b"
                                  : "#e5e7eb"
                              }
                            />
                          ))}

                          <span className="ms-1 text-muted">
                            ({ratingValue.toFixed(1)})
                          </span>

                        </div>

                        <div className="mm-price">
                          <span className="mm-new">
                            QAR{item.price || item.price_per_unit}
                          </span>
                          {item.old && (
                            <span className="mm-old">{item.old}</span>
                          )}
                        </div>

                        <button
                          className="mm-cart-btn"
                          onClick={() => addToCart(item)}
                        >
                          <FaShoppingCart /> Add
                        </button>

                      </div>

                    </div>
                  </div>
                );
              })}

            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default SpecialProducts;